import { BLUR_VALUE, BLUR_VALUE_2 } from './constants'

export function isArray(val): boolean {
  return Object.prototype.toString.call(val) === '[object Array]'
}
export function isObject(val): boolean {
  return Object.prototype.toString.call(val) === '[object Object]'
}
export function isString(val): boolean {
  return Object.prototype.toString.call(val) === '[object String]'
}

export const isSSR = (function () {
  try {
    return !(typeof window !== 'undefined' && document !== undefined)
  } catch (e) {
    return true
  }
})()

export const isEmpty = (data: any) => {
  if (['', undefined, null].includes(data)) {
    return true
  }
  if (Array.isArray(data) && data.length === 0) {
    return true
  }

  if (JSON.stringify(data) === '{}') {
    return true
  }
  return false
}

export function isTablet(ua: string) {
  const userAgent = ua.toLowerCase()
  // 判断是否是 iPad
  if (userAgent.indexOf('ipad') !== -1) {
    return true
  }

  // 判断是否是 Android 平板
  if (userAgent.indexOf('android') !== -1 && userAgent.indexOf('mobile') === -1) {
    return true
  }

  return false
}

export const isMobile = (ua: string | undefined) => {
  if (!ua) return false
  if (isTablet(ua)) {
    return false
  }
  if (
    ua.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    )
  ) {
    return true
  }
  return false
}

export const isNumber = (val: any) => {
  return Number.isFinite(val)
}

export const checkImageUrl = (val: string) => {
  if (typeof val !== 'string') return ''
  const urlRegex = /^(https?:\/\/)/
  const pathRegex = /^\/.*/
  if (urlRegex.test(val) || pathRegex.test(val)) {
    return val
  }
  return ''
}

export const isBlurValue = (val: any) => {
  return val === BLUR_VALUE || val === BLUR_VALUE_2
}
